import type { UserSettingsDto } from '@/api/ApiClient';
import { useTreeStore } from '@/stores/treeStore';
import { DATA_ROUTE_ROOT_MODE_KEY } from '@/lib/tree/dataRouteTreeConstants';

export { DATA_ROUTE_ROOT_MODE_KEY } from '@/lib/tree/dataRouteTreeConstants';

type SettingsWithDataRouteFlag = UserSettingsDto & Partial<Record<typeof DATA_ROUTE_ROOT_MODE_KEY, boolean>>;

/**
 * True when the current tree factory was initialized for the `/data/...` data-tree experience (not the project explorer).
 */
export function isCanonicalDataRouteTree(): boolean {
  const settings = useTreeStore.getState().factory?.userSettings as SettingsWithDataRouteFlag | undefined;
  return Boolean(settings?.[DATA_ROUTE_ROOT_MODE_KEY]);
}
